export default __webpack_public_path__ + "static/media/6_of_diamonds.b19504c1.png";